import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CoreStore } from '../models/core.models';
import { selectAppState } from './app.selector';
import { AppState } from '../app.state';

export const selectCoreStore = createSelector(
    selectAppState,
    (state: AppState) => state.core
)

//export const selectCoreStore = createFeatureSelector<CoreStore>('core');
//export const selectRedirectUrl = (state: CoreStore) => state.redirectUrl;

export const selectRedirectUrl = createSelector(
    selectCoreStore,
    (state) => state.redirectUrl
)